import axios from "axios";
import AuthService from "./auth.service";
import { store } from "../redux/store";
import { authActions } from "redux/slices/auth";
import { log } from "../utils/logger.util";
import { config as configs } from "config";
import ToasterService from "../utils/toaster.util";

axios.defaults.baseURL = configs.API_URL;
const CancelToken = axios.CancelToken;

let source = CancelToken.source();


axios.interceptors.request.use(
	(config: any) => {
		const { url, data, method } = config;

		// log(`http ${method} request`, url, "\n", data);

		return { ...config, cancelToken: source.token };
	},
	(error: any) => Promise.reject(error)
);

axios.interceptors.response.use(
	(res: any) => {
		const { config } = res;
		const { url, method } = config;
		const { data, message } = res.data;

		// log(`http ${method} response`, url, "\n", data);
		// `silentToast` is for callers that fan one user action out over several
		// requests: without it, saving a class's four periods stacks four
		// identical "Special price updated" toasts. Those callers summarise once
		// themselves. Errors are never silenced — each one names a different row.
		if (!config?.silentToast) ToasterService.showSuccess(message);

		return res;
	},
	(err: any) => {
		const { config, message: msg, response } = err;
		const message = response?.data?.message;
		const { url, method } = config;

		log(`http ${method} error`, url, message || msg);
		ToasterService.showError(message || msg);

		if (!response) throw err;

		const { code } = response.data;

		const errorCode = response.data?.errorCode;

		if (response.status === 403 && errorCode === "MUST_CHANGE_PASSWORD") {
			const user = store.getState().auth?.user;
			if (user) {
				store.dispatch(
					authActions.setUser({ ...user, mustChangePassword: true })
				);
			}
			throw err;
		}

		if (
			code === 401 &&
			(message === "Unauthorized" ||
				message === "Password has been changed, Login again" ||
				message === "Login session has been expired, Login again")
		) {
			AuthService.logout();
			source.cancel(message);

			setTimeout(() => {
				source = CancelToken.source();

				if (window.location.pathname !== "/") window.location.assign("/");
			}, 300);
		}

		throw err;
	}
);

const http = {
	get: axios.get,
	put: axios.put,
	post: axios.post,
	patch: axios.patch,
	delete: axios.delete,
	setJWT: () => {
		axios.defaults.headers.common["Authorization"] =
			localStorage.getItem("token") || "";
	},
	setMultiPart: () => {
		axios.defaults.headers.common["Content-Type"] = "multipart/form-data";
	},
};

export default http;
